var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.reportLoaded)?_c('div',{staticClass:"report",attrs:{"id":"report"}},[(_vm.report.origin==='C3')?_c('C3',{attrs:{"report":_vm.report}}):_vm._e(),(_vm.report.origin==='C4')?_c('C4',{attrs:{"report":_vm.report}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }